import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import _uniqBy from "lodash/uniqBy";
import _isFunction from "lodash/isFunction";
import _isString from "lodash/isString";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.small.js";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { countryList } from 'enums/countries';
import InputContainer from '../InputContainer';
import { usePhoneInput } from './usePhoneInput';
import Input from '../Input';
import Dropdown from '../Dropdown';
import { phoneInputContainer, phoneInputCountrySelect } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var numberPattern = function numberPattern(val) {
  return /[0-9]/.test(val);
};

var countryListOptions = _uniqBy(countryList.sort(function (a, b) {
  return Number(a.phone.slice(1)) > Number(b.phone.slice(1)) ? 1 : -1;
}).map(function (el) {
  return _objectSpread(_objectSpread({}, el), {}, {
    duplicates: countryList.filter(function (i) {
      return i.phone === el.phone;
    }).map(function (i) {
      return i.name;
    })
  });
}), 'phone');

var PhoneInput = function PhoneInput(props) {
  var required = props.required,
      label = props.label,
      placeholder = props.placeholder,
      validate = props.validate,
      disabled = props.disabled,
      small = props.small,
      inputProps = props.inputProps,
      dropdownProps = props.dropdownProps,
      onKeyDown = props.onKeyDown;

  var _usePhoneInput = usePhoneInput(props, countryListOptions),
      inputValue = _usePhoneInput.inputValue,
      dropdownValue = _usePhoneInput.dropdownValue,
      handleBlur = _usePhoneInput.handleBlur,
      handleInputChange = _usePhoneInput.handleInputChange,
      handleDropdownChange = _usePhoneInput.handleDropdownChange,
      error = _usePhoneInput.error,
      isTouched = _usePhoneInput.isTouched;

  var hasError = isTouched && error;
  var hasValidation = _isFunction(validate) || required;
  return ___EmotionJSX(InputContainer, _extends({}, props, {
    error: error,
    isTouched: isTouched
  }), ___EmotionJSX("div", {
    css: phoneInputContainer(hasValidation)
  }, ___EmotionJSX(Dropdown, _extends({
    noClear: true,
    withSearch: true,
    small: small,
    disabled: disabled,
    options: countryListOptions,
    value: dropdownValue,
    placeholder: "\u041A\u043E\u0434",
    onChange: handleDropdownChange,
    css: phoneInputCountrySelect,
    onBlur: handleBlur,
    renderSelected: function renderSelected(val) {
      return val === null || val === void 0 ? void 0 : val.phone;
    },
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.phone;
    },
    hasError: hasError && !dropdownValue,
    displayKey: "phone",
    uniqueKey: "phone",
    searchKeys: ['phone', 'duplicates']
  }, dropdownProps)), ___EmotionJSX(Input, _extends({
    small: small,
    disabled: disabled,
    value: inputValue,
    placeholder: _isString(placeholder) ? placeholder : label ? "".concat(label, "...") : '',
    onChange: handleInputChange,
    onBlur: handleBlur,
    onKeyDown: onKeyDown,
    pattern: numberPattern,
    hasError: hasError && !(inputValue !== null && inputValue !== void 0 && inputValue.length)
  }, inputProps))));
};

PhoneInput.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  onError: PropTypes.func,
  placeholder: PropTypes.string,
  validate: PropTypes.func,
  horizontal: PropTypes.bool,
  dropdownProps: PropTypes.any,
  disabled: PropTypes.bool,
  small: PropTypes.bool,
  isTouched: PropTypes.bool,
  inputProps: PropTypes.object,
  onKeyDown: PropTypes.func,
  className: PropTypes.string
};
var PhoneInputRef = /*#__PURE__*/forwardRef(function (props, ref) {
  return ___EmotionJSX(PhoneInput, _extends({}, props, {
    componentRef: ref
  }));
});
PhoneInputRef.displayName = 'PhoneInput';
export default PhoneInputRef;